module.exports = __webpack_public_path__ + "html/modal-video_304c67bd6f9c267b191bf2548b4da54e.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/modal-video.html
// module id = ldoD
// module chunks = 151